import { render } from "./InfoTransactionPopup.vue?vue&type=template&id=f002b150"
import script from "./InfoTransactionPopup.vue?vue&type=script&lang=js"
export * from "./InfoTransactionPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__